<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <!-- 底部链接 -->
        <div class="footer-links" v-if="footerData.links && footerData.links.length > 0">
          <a
            v-for="link in footerData.links"
            :key="link.name"
            href="#"
            @click.prevent="handleFooterLink(link)"
          >
            {{ link.name }}
          </a>
        </div>
        
        <!-- 底部Logo与备案信息 -->
        <div class="footer-brand">
          <div class="footer-logo">
            <img
              class="logo-image"
              :src="footerData.logo.imageUrl"
              :alt="footerData.logo.altText"
            >
          </div>
          
          <!-- 版权与备案信息 -->
          <div class="footer-legal">
            <p class="footer-copyright">{{ footerData.copyright }}</p>
            <p class="footer-icp">
              <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">
                粤ICP备2026035227号-1
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'CommonFooter',
  props: {
    // 通过 props 接收自定义数据
    footerData: {
      type: Object,
      default: () => ({
        links: [],
        logo: {
          imageUrl: require('@/assets/image/logo-白.png'),
          altText: "巴斯德生物科技"
        },
        copyright: '© 2025 - 2026 深圳市巴斯德医疗器械有限公司 版权所有'
      })
    }
  },
  data() {
    return {
      showBackToTop: false
    }
  },
  mounted() {
    // 添加滚动监听
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    // 移除监听
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    // 处理链接点击
    handleFooterLink(link) {
      // 根据链接类型进行跳转
      if (link.name === '服务协议' || link.name === 'Terms of Service') {
        if (this.$route.path !== '/terms') {
          this.$router.push('/terms');
        }
      } else if (link.name === '隐私政策' || link.name === 'Privacy Policy') {
        if (this.$route.path !== '/privacy') {
          this.$router.push('/privacy');
        }
      } else if (link.name === '合作洽谈' || link.name === 'Cooperation') {
        if (this.$route.path !== '/cooperation') {
          this.$router.push('/cooperation');
        }
      } else if (link.name === '招聘资讯' || link.name === 'Careers') {
        // 可以添加招聘页面路由
        console.log('招聘页面待开发');
      } else {
        console.log('点击了链接:', link.name)
      }
    },
    
    // 滚动处理
    handleScroll() {
      this.showBackToTop = window.scrollY > 300
    },
    
    // 返回顶部
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
}
</script>

<style scoped>
.footer {
  background: linear-gradient(180deg, #1a1a1a 0%, #2c2c2c 100%);
  color: #999;
  padding: 50px 0 40px;
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}

.footer-links {
  display: flex;
  gap: 40px;
  align-items: center;
  justify-content: center;
  margin-bottom: 40px;
}

.footer-links a {
  color: #999;
  text-decoration: none;
  font-size: 15px;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 4px;
  transition: all 0.3s ease;
  position: relative;
  white-space: nowrap;
}

.footer-links a:hover {
  color: #00D4B4;
  background-color: rgba(0, 212, 180, 0.1);
  transform: translateY(-2px);
}

.footer-links a::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 2px;
  background-color: #00D4B4;
  transition: all 0.3s ease;
  transform: translateX(-50%);
}

.footer-links a:hover::after {
  width: 80%;
}

.footer-brand {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 25px;
  padding-top: 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  width: 100%;
  max-width: 600px;
}

.footer-logo {
  text-align: center;
}

.logo-image {
  height: 80px !important;
  width: auto !important;
  transition: transform 0.3s ease, filter 0.3s ease;
  filter: brightness(0.9);
}

.logo-image:hover {
  transform: scale(1.05);
  filter: brightness(1);
}

.footer-legal {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.footer-copyright {
  text-align: center;
  font-size: 13px;
  color: #888;
  letter-spacing: 0.5px;
  margin: 0;
}

.footer-icp {
  text-align: center;
  font-size: 12px;
  margin: 0;
}

.footer-icp a {
  color: #666;
  text-decoration: none;
  transition: color 0.3s ease;
  padding: 4px 8px;
  border-radius: 3px;
}

.footer-icp a:hover {
  color: #00D4B4;
  background-color: rgba(0, 212, 180, 0.08);
}

/* 响应式设计 - 移动端适配 */
@media (max-width: 768px) {
  .footer {
    padding: 40px 20px 30px;
  }

  .footer-links {
    flex-direction: column;
    gap: 15px;
    margin-bottom: 30px;
  }

  .footer-links a {
    font-size: 14px;
    padding: 10px 20px;
    width: 100%;
    text-align: center;
  }

  .footer-links a:hover {
    background-color: rgba(0, 212, 180, 0.15);
  }

  .footer-links a:hover::after {
    width: 60%;
  }

  .footer-brand {
    padding-top: 25px;
    gap: 20px;
  }

  .logo-image {
    height: 90px !important;
  }

  .footer-copyright {
    font-size: 12px;
    line-height: 1.6;
  }
}
</style>